export default {
  Name: "",
  Description: null,
  Percentaje: 0,
  CloseDeals: false,
  Deals: [],
  ActivityConditions: null,
  Id: 0,
  IsEnabled: false,
  IsNull: false
};
